/* unplugin-vue-components disabled */import script from "./KeywordVerification.vue?vue&type=script&lang=ts&setup=true"
export * from "./KeywordVerification.vue?vue&type=script&lang=ts&setup=true"

import "./KeywordVerification.vue?vue&type=style&index=0&id=5ce867ad&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ce867ad"]])

export default __exports__